import { render, staticRenderFns } from "./CheckboxesEditor.vue?vue&type=template&id=0921cea9"
import script from "./CheckboxesEditor.vue?vue&type=script&lang=js"
export * from "./CheckboxesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports